import React, { ReactNode } from 'react';
import styled, { useTheme } from 'styled-components';

import { colors } from '../../../core';
import { Column } from '../../styles';
import Heading from '../Heading';
import Icon from '../Icon';
import LoadingSpinner from '../LoadingSpinner';
import Text from '../Text';

export interface ActivityLoaderProps {
  headerText: string;
  bodyText: string;
  isLoading: boolean;
  hasError?: boolean;
  hintText?: ReactNode;
}

const ActivityLoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 3px 0;
  border-radius: 4px;
  max-width: 600px;
  padding: 10px;
`;

const HeaderStyle = styled(Heading)`
  margin-top: 20px;
  color: ${colors.darkCerulean};
`;

const ActivityLoader = ({
  isLoading,
  hasError,
  headerText,
  bodyText,
  hintText,
}: ActivityLoaderProps) => {
  const theme = useTheme();

  return (
    <ActivityLoaderContainer>
      {hasError && <Icon type="alert" size={80} viewSize={100} color={theme.errorColor} />}
      {!isLoading && !hasError && <Icon type="complete" size={80} color={colors.success} />}

      <HeaderStyle size={4}>{headerText}</HeaderStyle>
      <Text size="medium" align="center">
        {bodyText}
      </Text>

      {isLoading && !hasError && (
        <Column style={{ width: '120px', height: '80px' }}>
          <LoadingSpinner size="large" color={colors.darkCerulean} />
        </Column>
      )}

      {hintText && <Column>{hintText}</Column>}
    </ActivityLoaderContainer>
  );
};

export default ActivityLoader;
